import React from "react";
import Select from "react-select";
const ViewContacts = () => {
  const options = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "pending", label: "Pending" },
    { value: "suspended", label: "Suspended" },
  ];
  return (
    <>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewContacts"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header bg-primary">
          <h4 id="offcanvasRightLabel" className="text-white">
            View Contact - Sunsai Enterprises
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body" style={{ marginTop: "-1.5rem" }}>
          <form>
            <div className="mb-3">
              <label className="form-label">Profile Image</label>
              <input type="file" className="form-control" />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">First Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="/"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Last Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="/"
                  required
                />
              </div>

              <div className=" col-md-6 mb-3">
                <label className="form-label">Position</label>
                <input type="text" className="form-control" />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Email"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Phone</label>
                <input type="text" className="form-control" placeholder="+91" />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Direction</label>
                <Select options={options} />
              </div>

              <div className=" col-md-6 mb-3">
                <label className="form-label">Password</label>
                <input type="password" className="form-control" />
              </div>
            </div>

            <div className="row ms-2 mt-2">
              <div className="form-check col-md-6 mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked
                />
                <label className="form-check-label">Primary Contact</label>
              </div>
              <div className="form-check col-md-6 mb-3">
                <input className="form-check-input" type="checkbox" />
                <label className="form-check-label">
                  Send SET password email
                </label>
              </div>
            </div>
            <h6 className="mb-2">Permissions</h6>
            <div className="row">
              <p className="text-danger">
                Make sure to set appropriate permissions for this contact
              </p>
              {[
                "Invoices",
                "Estimates",
                "Contracts",
                "Proposals",
                "Support",
                "Projects",
              ].map((perm) => (
                <div className="col-md-4" key={perm}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked
                    />
                    <label className="form-check-label">{perm}</label>
                  </div>
                </div>
              ))}
            </div>

            <h6 className="mt-3 mb-2">Email Notifications</h6>
            <div className="row">
              {[
                "Invoice",
                "Estimate",
                "Credit Note",
                "Project",
                "Tickets",
                "Contract",
                "Task",
              ].map((notif) => (
                <div className="col-md-4" key={notif}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked
                    />
                    <label className="form-check-label">{notif}</label>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-4 d-flex justify-content-end">
              <button type="button" className="btn btn-secondary me-2">
                Close
              </button>
              <button type="submit" className="btn btn-warning">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ViewContacts;
